import { createContext, useEffect, useState, useMemo } from 'react';

export const ViewportContext = createContext();

const ViewportProvider = (props) => {
    const { children, deviceTypeHeaderAgent } = props;

    const typesViewport = {
        VP_MOBILE: 'VP_MOBILE',
        VP_SMALL: 'VP_SMALL',
        VP_REGULAR: 'VP_REGULAR',
        VP_LARGE: 'VP_LARGE'
    };

    const [viewport, setViewport] = useState(
        deviceTypeHeaderAgent === 'mobile' ? typesViewport.VP_MOBILE : typesViewport.VP_REGULAR
    );
    const [isMobileDevice, setIsMobileDevice] = useState(deviceTypeHeaderAgent === 'mobile');
    const [isMobile, setIsMobile] = useState(deviceTypeHeaderAgent === 'mobile');
    const [isOnlyMobile, setIsOnlyMobile] = useState(deviceTypeHeaderAgent === 'mobile');
    const [zoomNavigator, setZoomNavigator] = useState(1);

    const updateZoom = () => {
        // Intenta utilitzar window.devicePixelRatio si està disponible
        let zoom = window.devicePixelRatio || 1;

        // Si estem en un navegador com Safari on devicePixelRatio pot no ser fiable
        if (navigator.userAgent.includes('Safari') && !navigator.userAgent.includes('Chrome')) {
            const divZoom = document.createElement('div');
            divZoom.style.width = '1in';
            divZoom.style.visibility = 'hidden';
            divZoom.style.position = 'absolute';
            document.body.appendChild(divZoom);

            const pixelsPerInch = divZoom.offsetWidth;
            document.body.removeChild(divZoom);

            zoom = pixelsPerInch / 96; // 96 és el valor estàndard de PPI
        }
        setZoomNavigator(zoom);
    };

    const isMobileUserAgent = () => /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini|Mobile/i.test(navigator.userAgent);

    const updateViewPort = () => {
        let _viewport;
        if (window.innerWidth < 720) {
            _viewport = typesViewport.VP_MOBILE;
        } else if (window.innerWidth < 1024) {
            _viewport = typesViewport.VP_SMALL;
        } else if (window.innerWidth < 1680) {
            _viewport = typesViewport.VP_REGULAR;
        } else {
            _viewport = typesViewport.VP_LARGE;
        }

        if (isMobileUserAgent()) {
            _viewport = typesViewport.VP_MOBILE;
        }

        setViewport(_viewport);
        setIsMobile([typesViewport.VP_MOBILE, typesViewport.VP_SMALL].includes(_viewport));
        setIsOnlyMobile(_viewport === typesViewport.VP_MOBILE);
        updateZoom();
    };

    useEffect(() => {
        setIsMobile([typesViewport.VP_MOBILE, typesViewport.VP_SMALL].includes(viewport));
        setIsOnlyMobile(viewport === typesViewport.VP_MOBILE);
    }, [viewport]);

    useEffect(() => {
        window.addEventListener('resize', updateViewPort);
        setIsMobileDevice(/Mobi|Android/i.test(navigator.userAgent));
        updateViewPort();
        return () => window.removeEventListener('resize', updateViewPort);
    }, []);

    const value = useMemo(
        () => ({
            viewport,
            isMobile,
            isOnlyMobile,
            isMobileDevice,
            zoomNavigator,
            typesViewport
        }),
        [viewport, isMobile, isOnlyMobile, isMobileDevice, zoomNavigator]
    );

    return <ViewportContext.Provider value={value}>{children}</ViewportContext.Provider>;
};

export default ViewportProvider;
